// const { FaissStore } = require("langchain/vectorstores/faiss");
// const { OpenAIEmbeddings } = require("langchain/embeddings/openai");
// const { TextLoader } = require("langchain/document_loaders/fs/text");
// const { RecursiveCharacterTextSplitter } = require("langchain/text_splitter");
// const { createRetrieverTool } = require("langchain/agents/toolkits");
// const {
//   createConversationalRetrievalAgent,
// } = require("langchain/agents/toolkits");
// const { ChatOpenAI } = require("langchain/chat_models/openai");

// process.env.OPENAI_API_KEY =
//   "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";

// export async function sendMsgToOpenAI(text) {
//   const loader = new TextLoader("data42.txt");
//   const docs = await loader.load();
//   const splitter = new RecursiveCharacterTextSplitter({
//     chunkSize: 1000,
//     chunkOverlap: 0,
//   });

//   const texts = await splitter.splitDocuments(docs);

//   const vectorStore = await FaissStore.fromDocuments(
//     texts,
//     new OpenAIEmbeddings()
//   );

//   const retriever = vectorStore.asRetriever();

//   const tool = createRetrieverTool(retriever, {
//     name: "search_mit_classes",
//     description: "Searches and returns MIT data.",
//   });

//   const model = new ChatOpenAI({
//     temperature: 0,
//   });

//   const executor = await createConversationalRetrievalAgent(model, [], {
//     verbose: true,
//   });

//   const result = await executor.call({
//     input: text,
//   });

//   return result.output;
// }

const { OpenAI } = require("openai");

const openai = new OpenAI({
  apiKey: "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",
  dangerouslyAllowBrowser: true,
});

let previous_messages = [
  {
    role: "user",
    content: `You are ChatMIT, a chatbot to help prospective and current MIT students alike. I will be giving you a series of statistics, data, and testimonies from MIT. This data should be integrated into you knowledge base. Make the user aware when testimonies are being told, etc. If the topic is out of the scope of MIT, do not answer the question.`,
  },
  {
    role: "user",
    content: `Demographics of Class of 2027:

    For the MIT Class of 2027
    Some facts and figures about the 1,092 members⁠01 of the Class of 2027. See also Admissions statistics.
    
    Gender*
    Men	49%
    Women	48%
    Another gender identity	4%
    Did not disclose gender identity	2%
    Citizenship & self-reported ethnicity*
    U.S. citizens & permanent residents
    Number of U.S. states represented: 49	90%
    American Indian/Alaskan Native	2%
    Asian American	40%
    Black/African American	15%
    Hispanic/Latino	16%
    Native Hawaiian/Pacific Islander	1%
    White/Caucasian	38%
    International citizens
    Number of countries represented: 59	10%
    *Total exceeds 100% as students may indicate more than one option.`,
  },
  {
    role: "user",
    content: `What if I don’t have a class rank or GPA?
    Please don’t be overly concerned about your class rank or GPA (grade point average) or even whether your school calculates them. With our holistic admissions process, we’re much more interested in how an applicant “fits” with our culture than if they were No. 1 in their school.
    
    If your school doesn’t calculate GPA, please don’t convert your grades to a U.S. GPA system. Simply leave spaces blank if the information is not available.`,
  },
  {
    role: "user",
    content: `What is Concourse?
    Concourse is a unique community of first-year students committed to learning in a small interactive group environment with dedicated teachers.
    
    Concourse offers small classes in the math and science GIRs as well as small, foundational humanities classes that explore fundamental human questions, such as the meaning of human nature, the basis and character of morality, the necessary conditions for liberty, the proper role of science, and the possibility of finding true happiness.
    
    Concourse has unique facilities to foster this intellectual community. All Concourse students have 24/7 use of a community lounge where ideas and people come together, not only for study but also for informal discussions, class tutorials, weekly Friday lunches and seminars, and spontaneous breakfasts and dinners.
    `,
  },
  {
    role: "user",
    content: `Does MIT offer a pre-med program?
    Approximately 10 percent of MIT’s senior class enter medical and other health profession schools each year. MIT doesn’t offer a premed or prehealth major; rather, students can pursue a variety of majors and take classes in any department. However, students need to fulfill certain subject requirements to apply to medical, dental or other health-related professional schools. Students interested in a career in medicine or other health-related professions are encouraged to complete a prehealth registration meeting with Prehealth Advising during the spring semester of their sophomore year.
    `,
  },
  {
    role: "user",
    content: `What career services are available?
    MIT Career Advising & Professional Development guides all students—current and alumni—as they explore and prepare for careers. Whether you are planning for a career, searching for an internship or job, or applying to graduate or professional school, CAPD has services and programs that can help.
    
    Approximately 52% of graduates go directly to employment, and 43% of the Class of 2022 went directly to grad school. 60% of MIT alums eventually go to graduate school, including 13% to medical school, 3% to law school, and 12% to business school.
    
    The average starting salary for an MIT undergraduate—regardless of major— is $115,461.`,
  },
  {
    role: "user",
    content: `How does pass/no record work?
    Here’s something else to love about MIT!
    
    The first semester at MIT is graded on a pass/no record basis: if you pass the class you get a “pass” on your transcript;  if not, there’s no record you took it. The second semester is similar, except that if you pass, you get a letter grade of A/B/C.
    
    As part of the flexible pass/no record grading option, you may designate up to 48 units to be graded on a pass/no record basis after your first term, and at any time during your course of study.
    `,
  },
  {
    role: "user",
    content: `How does one attain a Pirate License?
    arrrrrrr!
    
    Come to MIT and earn your Pirate Certificate.
    
    All MIT undergraduates must complete eight points of physical education classes to graduate—but students that complete courses in archery, pistol shooting, sailing, and fencing are granted pirate status with a tangible certificate. Blogger Abby H. ’20 is one of the students who has earned official MIT Pirate status.
    
    “The courses are cerebral,’’ said Carrie Sampson Moore, director of physical education. “They’re tactical. They involve strategy. Plus they’re a challenge to complete.’’
    
    So you best be careful whilst sailing the Charles!`,
  },
  {
    role: "user",
    content: `UROP Experience Testimony:

    My job on IQ-TREE has been running for more than an hour.
    
    For my UROP, I’m exploring the role of a bacterial communication system called quorum sensing (QS) in marine microbes, where bacteria produce molecules and behave according to the concentration of those molecules. Right now, I’m trying to build a phylogenetic tree that helps me analyze how similar the protein sequences of certain enzymes that produce QS molecules are.
    
    It’s not an issue with the size of my tree — I’ve only put in about 100 entries, and there are people out there analyzing trees with thousands of sequences.
    
    Turns out it’s because some of the sequences I’ve put in are way too similar, and essentially, the tree search is stuck in a loop, constantly going back and trying to find a better alignment, over and over again.
    
    This summer, I stayed in Cambridge to work on my UROP full time. There are some things that haven’t exactly turned out the way I expected or wanted them to, and this month especially, I’ve found myself curled up in my room, too exhausted and numb to deal with all of my responsibilities.
    
    Still, I’ve done a lot this summer. I’ve made a lot of progress on my research, and I’ll be continuing it as a SuperUROP this year with the Civil and Environmental Engineering department.
    
    Last semester I took five classes, which was a first for me.
    6.1220/6.046 (Design and Analysis of Algorithms): This is a notoriously difficult class. I dropped it my junior fall right before the first exam because I knew there was no hope for me, the way things had been going. I took it again this spring, and it was still hard, but I passed, and I’m really really proud of that!!!
    7.05 (General Biochemistry): I think this was one of my favorite classes — it was endlessly entertaining and engaging. There was a lot of material relevant to my UROP as well, as a plus.
    7.002 (Fundamentals of Experimental Molecular Biology): I needed this class because a lab class for my major wasn’t offered this year, so I took this and I’m taking 7.003 this fall. Chris and I were lab partners, which was fun.
    21L.487 (Modern Poetry): Back in freshman year, I took 21L.004 with Prof. Tapscott. It was over Zoom, but his unique sense of humor and attitudes toward poetry made it a good time. Being in his class in person this time was a treat.
    21A.502 (Fun and Games: Cultural Perspectives): Such a fun class (as you can expect from the name!) I’m doing my HASS concentration in Anthropology, and this class brought so much joy to me every week. We went on field trips to Pandemonium Games in Central and Sinha Capoeira in Somerville. It was so immersive and the readings were endlessly interesting — and Prof. Jones is amazing! I’m scheduled to take another class with him next spring :)
    After a couple of rough semesters as I tried to adjust to life at MIT, I achieved an all-A semester this spring! Grades aren’t everything, but this was a really big moment for me.
    
    In April, I presented a poster at the MIT Microbiome Symposium on my work!
    
    RIP East Campus, but I’m moving out in two days to a beautiful, airy apartment with friends I adore endlessly. We have color-coded spreadsheets to coordinate group orders? And Tiffany even drew up a floor plan?? I’m excited beyond belief to make this place ours, and to spoil my cat with cute cat trees and unnecessarily fancy litter boxes (it looks like a plant!). Expect an apartment tour at some point.
    `,
  },
  {
    role: "user",
    content: `Study Spots at MIT:
    
    ~ Green Building (Building 54-1725)
    
    Pros
    
    - free coffee and tea
    - great view
    - super comfy couch
    - good table space
    - has a printer!!
    
    Cons
    
    - not enough natural light
    
    ~ 14th Floor Lounge
    
    Pros
    
    - great view
    - free coffee/sparkling water
    - big tables and comfy chairs/sofas
    
    Cons
    
    - only a few tables, so you’ll probably have to share during the day when it’s busy
    
    
    ~ Ida Green Room (9th Floor Lounge)
    
    Pros
    
    - incredible view
    - spacious
    - lots of couch seating
    - free coffee/tea
    
    Cons
    
    -only one large table + the seats with it are uncomfortable
    - lighting is eh
    
    ~ DUSP⁠01 (Building 9) 
    
    there are tons of nooks to study in on every floor of building 9 (except maybe the 3rd, I didn’t see much there). there’s a lounge on the second floor and a big workspace with a bunch of chairs, tables, and couches on the fifth.
    
    Pros
    
    - lots of seating options
    - good outlet access
    - plenty of natural light on second floor
    - big tables
    - small circular tables are a nice height
    
    Cons
    
    - creepy lighting on higher floors at night
    - second floor lounge is kind of small and literally never empty
    
    ~ MIT.nano (Building 12) 
    
    1st Floor Booths:
    
    Pros
    
    - booths are great for solo/partner work
    - comfortable seating
    - big table
    - good outlet access
    
    Cons
    
    - people are always walking by when classes end and it’s distracting
    
    3rd/4th Floor:
    
    Pros
    
    - comfy seating
    - great view of dome (from 3rd floor)
    - quiet
    - nano is pretty (I disagree with those who say it looks like an insane asylum)
    
    Cons
    
    - outlet access is bad
    - tables are short
    
    
    ~ Brain and Cognitive Sciences (Building 46):
    
    “Plant Room” aka Reading Terrace
    everyone thinks this is a niche spot, but half of campus has worked here. fun fact: it was the first place I ever psetted at MIT!`,
  },
  {
    role: "user",
    content: `What HASS Concentrations can I choose from? 

    - African and African Diaspora Studies
    - American Studies
    - Ancient and Medieval Studies
    - Anthropology
    - Archaeology and Archaeological Science
    - Art, Culture, and Technology
    - Asian and Asian Diaspora Studies
    - Comparative Media Studies
    - Computing and Society
    - Development Economics
    - Economics
    - Education
    - English Language Studies (ELS)
    - Ethics
    - Global Languages
    -> Chinese
    -> French
    -> German
    -> Japanese
    -> Korean 
    -> Portuguese
    -> Russian
    -> Spanish
    -> Other Languages
    -> Studies in International Literatures and Cultures (SILC)
    -> Theory of Languages
    - History
    - History of Architecture, Art, and Design
    - Latin American and Latino/a Studies
    - Legal Studies
    - Linguistics
    - Literature
    - Middle Eastern Studies
    - Music
    - Philosophy
    - Political Science
    - Religious Studies
    - Russian and Eurasian Studies
    - Science, Technology, and Society (STS)
    - Theater Arts
    - Urban Studies
    - Women's and Gender Studies
    - Writing`,
  },
  {
    role: "user",
    content: `Services:

    - Alpha Phi Omega is a national, co-ed, service fraternity, centered on the principles of leadership, friendship, and service. The Alpha Chi chapter at MIT provides community service to the MIT campus, greater Boston region, and the New England area.
    - ASHA is a group dedicated to help address the problem of basic education for underprivileged children in India.
    -Amnesty International
    - The MIT Office of Career Services and Preprofessional Advising
    - Circle K is the world's largest co-ed collegiate service organization. The MIT club does service projects for the people of our community and with other Circle K clubs throughout New England.
    - The MIT Entrepreneurs Club (e-club) helps develop new business ventures. They meet weekly, sponsor special events, and co-organize and produce the MIT $10K Entrepreneurial Competition.
    - The Educational Studies Program is a thirty seven year old MIT student activity committed to providing opportunities for learning in the greater Boston community.
    - The Harvard/MIT Cooperative Society is MIT's campus bookstore. The Coop has a wide selection of books and merchandise at the MIT Coop at Kendall Square and in the MIT Student Center.
    - The MIT Hunger Action Group seeks to educate the MIT community about hunger issues and alleviate local hunger concerns.
    - The MIT Kosher Ko-op serves kosher meals every Monday and Wednesday in the religious activites building.
    - The Lecture Series Committee presents a variety of movies and lectures on the MIT campus.
    - MedLINKs are student volunteers who can help you with any questions you might have about your health or the MIT Medical Department.
    - The MIT Museum
    - Project America is an initiative to inspire long-term, ongoing constructive action and community responsibility by promoting and coordinating an annual national community improvement day.
    - A Safe Ride (MIT safety shuttle) van schedules are on line.
    - The Source, the information and service outpost in the lobby of the Student Center, provides a variety of information to the MIT Community, including Boston area and MIT events listings, Restaurant suggestions and information, academic information, and connections to various sections of TechInfo.
    - The Student Alumni/ae Connection is a student organization which provides opportunities for student and alumni/ae interaction, promotes student awareness of the Alumni/ae Association, increases class identity, develops student pride and spirit for the support of MIT and enhances professional leadership development.
    - The Student Ambassadors, coming from varied backgrounds, serve as liaisons between the MIT student community and two other important groups: former students and prospective students. We are pleased to provide perspectives on life at MIT as a student.
    `,
  },
  {
    role: "user",
    content: `What software is available to students for free or at a discount?

    Actual Technologies:
    - Actual ODBC Driver for Oracle
    
    
    
    Is there useful equipment I can get from MIT during my time there?
    
    IS&T maintains a limited pool of computing equipment available for loan to eligible MIT students, faculty, and staff. Note that there are separate options and loan request forms for students and for faculty and staff. Allow one to two weeks for delivery.
    
    Available for students:
    
    Laptops (Apple, Dell) for temporary use
    iPad bundle available only for undergraduates and those graduate students working as teaching assistants for undergraduate classes
    
    Available for faculty and staff:
    
    Tablets - Apple iPad, Microsoft Surface
    Laptops - Apple, Dell
    
    Requirements
    Students requesting equipment must be currently enrolled.
    Faculty and staff must provide a valid Institute cost object, which will be used for tracking purposes. Note: The cost object provided will be charged for the full replacement value of any equipment that is not returned.
    `,
  },
];
export async function sendMsgToOpenAI(messages) {
  let together = [...previous_messages, ...messages];
  console.log(together);
  const res = await openai.chat.completions.create({
    model: "gpt-3.5-turbo",
    messages: together,
  });

  return res.choices[0].message;
}
